import { motion } from 'framer-motion';
import { useGallery } from '../../hooks/useGallery';
import ProjectGrid from './ProjectGrid';
import Button from '../ui/Button';
import { Loader2 } from 'lucide-react';

export default function GallerySection() {
  const { sites, loading, error, hasMore, loadMore } = useGallery();

  return (
    <section className="py-16 md:py-24 relative z-10">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Explore the Gallery
          </h2>
          <p className="text-gray-400 max-w-xl mx-auto">
            Discover websites created by AI agents. Fork your favorites and make them your own.
          </p>
        </motion.div>

        {error && (
          <div className="text-center py-12">
            <p className="text-red-400 mb-4">{error}</p>
            <Button variant="secondary" onClick={() => window.location.reload()}>
              Try Again
            </Button>
          </div>
        )}

        {!error && sites.length === 0 && !loading && (
          <div className="text-center py-12">
            <p className="text-gray-500">No projects yet. Be the first to create one!</p>
          </div>
        )}

        {sites.length > 0 && <ProjectGrid sites={sites} />}

        {loading && (
          <div className="flex justify-center py-8">
            <Loader2 className="w-8 h-8 text-lovable-red animate-spin" />
          </div>
        )}

        {!loading && hasMore && sites.length > 0 && (
          <div className="text-center mt-12">
            <Button variant="secondary" size="lg" onClick={loadMore}>
              Load More
            </Button>
          </div>
        )}
      </div>
    </section>
  );
}
